import { Component, OnInit } from '@angular/core';
import { OverviewClient, RegionDto } from '@shared/clients/api.generated';
import { MapAreasMapping } from '@shared/components/map/map-styles.model';
import { SidenavigationLink } from '@shared/components/sidenavigation/sidenavigation.model';
import { SvgIcon } from '@valg-shared/utils/svg-icon';
import { SidenavigationLinkType } from '@shared/components/page-layout/page-layout.model';
import {
  ExtendedElectionDto,
  LatestUpdatesRegionColumnDef,
  LatestUpdatesRegionDto,
  NUMBER_OF_DIPLAYED_UPDATES
} from '../election-overview.model';
import { ActivatedRoute, Router } from "@angular/router";
import { sortByAlphabeticallyIgnoreCase } from "../../../../utils/sort-utils";
import { CountStatus } from "@shared/components/count-status/count-status.component";
import { ElectionOverviewService } from "../election-overview.service";
import { MapAreaClickedEvent } from "@shared/components/map/map-events.model";

@Component({
  selector: 'valg-dk-rv-election-overview',
  templateUrl: './rv-election-overview.component.html'
})
export class RvElectionOverviewComponent implements OnInit {

  election?: ExtendedElectionDto;

  readonly SvgIcon = SvgIcon;
  public mapAreasMapping?: MapAreasMapping;

  links: SidenavigationLink[] = [];

  countStatuses: CountStatus[] = [];

  sideNavTitleType = SidenavigationLinkType.Region;
  parentLinkType = SidenavigationLinkType.Region;

  latestUpdatesDistrictColumnDef = LatestUpdatesRegionColumnDef;
  latestUpdates: LatestUpdatesRegionDto[] = [];

  regionalElectionOverview?: RegionDto[];

  constructor(
    private readonly overviewClient: OverviewClient,
    private readonly electionOverviewService: ElectionOverviewService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    await this.initializeCurrentElection();
    this.initializeNavigationItems();
    this.initializeElectionOverview();
  }

  private mapCountStatuses(regionalElectionOverview: RegionDto[]) {
    return regionalElectionOverview.map((region) => {
      return {
        id: region.id,
        name: region.name,
        percentage: region.countingPercentage ?? 0
      }
    });
  }

  private mapLatestUpdates(regionalElectionOverview: RegionDto[]) {
    return regionalElectionOverview.map((region) => {
      return {
        id: region.id,
        region: region.name,
        datetime: region.lastUpdate
      } as LatestUpdatesRegionDto
    });
  }

  private async initializeCurrentElection() {
    this.election = await this.electionOverviewService.getCurrentElection();
  }

  private initializeNavigationItems() {
    this.overviewClient.getElectionSideNavigation().subscribe((result) => {
      this.links = this.electionOverviewService.mapRegionalSideNavigation(result);
    });
  }

  private initializeElectionOverview() {
    this.overviewClient.getRegionalElectionOverview().subscribe((result) => {
      this.regionalElectionOverview = result.regions;
      this.mapAreasMapping = this.electionOverviewService.toMapAreaMapping(result.mapAreas);

      this.countStatuses = this.mapCountStatuses(this.regionalElectionOverview)
        .sort((a, b) => sortByAlphabeticallyIgnoreCase(a.name, b.name));

      this.latestUpdates = this.mapLatestUpdates(this.regionalElectionOverview).slice(0, NUMBER_OF_DIPLAYED_UPDATES);
    });
  }

  async onAreaClick($event: MapAreaClickedEvent) {
    const id = $event.data?.id;
    if (id) {
      const link = `region/${id}`
      await this.router.navigate([ link ], {
          relativeTo: this.route,
        }
      );
    }
  }
}
